import React, { useCallback, useContext, useEffect, useState } from 'react'
import { RequestContext } from '../../../../context/RequestContext';
import { FaCheckCircle, FaQuestionCircle } from 'react-icons/fa';
import { getAppSettings } from '../../../../api/app-setting/app-setting';
import { openModal } from '../../../../service/modal-service';

export const DeepCleanBooking = (props) => {
    const setRequestForm = props.setRequestForm
    const setIsQuickBook = props.setIsQuickBook;
    const countryName = props.countryName
    const currencyCd = props.currencyCd
    const deepCleanType = props.deepCleanType
    const showJobScope = props.showJobScope
    const serviceType = props.serviceType
    
    const [ unitType, setUnitType ] = useState("Condo")
    const [ floorSize, setFloorSize ] = useState(1000)
    const [ isSystemError, setIsSystemError ] = useState(false);
    const [ errorContent, setErrorContent ]  = useState({'header': "", 'body': ""})
    const [ waInd, setWaInd ] = useState(false)

    const { setRequestCriteria, setRequestDescription } = useContext(RequestContext);

    const handleUnitTypeChange = (e) => {
        setUnitType(e.target.value)
    }

    const handleFloorSizeChange = (e) => {
        setFloorSize(e.target.value)
    }

    const override = {
        display: "block",
        margin: "auto"
    };

    const openRequestForm = () => {
        window.scrollTo({ top: 0 });
        openModal(setRequestForm)
        // setRequestForm(true)
    }
    
    const confirmBook = (criteria) => {
        setRequestCriteria(criteria)
        setRequestDescription('')
        setIsQuickBook(true)
        // setRequestForm(true)
        openModal(setRequestForm)
    }
    
    const submit = (e) => {
        e.preventDefault()

        let criteria = [
            {0: serviceType, criteria: 'Type of service - ' + serviceType},
            {2: unitType, criteria: 'Type of residential unit - ' + unitType},
            {21: floorSize.toString(), criteria: 'Total floor size in Sqft - ' + floorSize},
        ]
        
        confirmBook(criteria)
    }
    
    useEffect(() => {
        setRequestCriteria([])
        setRequestDescription('')
        setIsQuickBook(false)
    }, [setIsQuickBook, setRequestCriteria, setRequestDescription])

    const fetchAppSetting = useCallback(async() => {
        try {
            const appSettings = await getAppSettings(countryName)
            setWaInd(appSettings.waBusinessInd)
        } catch (error) {
            console.log(error);
        }
    }, [countryName])
    
    useEffect(() => {
        if(!countryName) return

        fetchAppSetting()
    }, [countryName, fetchAppSetting])

  return (
    <>
        <div className='py-4 bg-white sm:bg-black/30 max-w-md sm:max-w-3xl mx-auto rounded-xl sm:text-white shadow'>            
            <div className='pt-2'>
                <p className='text text-center font-bold leading-relaxed uppercase'>
                    {deepCleanType}
                </p>
                <div className='py-5'>
                    <div className='hidden sm:block gap-5 text-center w-full pt-5'>
                        <form className='text-center w-full space-y-10' onSubmit={(e) => submit(e)}>
                            <div className='flex justify-center space-x-16'>
                                <div>
                                    <label className="block uppercase font-bold mb-2 text-sm">
                                        Residence Type
                                    </label>
                                    <select className="indent-2 h-12 text-orange-600 text-center bg-white w-40 shadow border rounded  focus:outline-none focus:shadow-outline focus:shadow-md focus:border-amber-200 focus:shadow-amber-200 focus:ring-1 ring-amber-200"
                                        name="unitType" value={unitType} onChange={(e) => handleUnitTypeChange(e)} style={{ transition: "all .15s ease" }} required>
                                        <option>HDB</option>
                                        <option>Condo</option>
                                        <option>Landed</option>
                                    </select>
                                </div> 
                                <div>
                                    <label className="block uppercase font-bold mb-2 text-sm">
                                        Floor Size (Sqft)
                                    </label>
                                    <input
                                        type="number" min={300}
                                        className="px-3 py-3 h-12 text-orange-600 w-40 text-center shadow appearance-none border rounded  focus:outline-none focus:shadow-outline focus:shadow-md focus:border-amber-200 focus:shadow-amber-200 focus:ring-1 ring-amber-200"
                                        placeholder="Floor size" name="floorSize" value={floorSize} onChange={(e) => handleFloorSizeChange(e)}
                                        style={{ transition: "all .15s ease" }} required
                                    />
                                </div> 
                            </div>
                            <div className='text-center'>
                                <button className='py-3 px-6 rounded-full bg-linear-to-tr from-amber-600 to-amber-400 text-white text-lg' type="submit">
                                    Get Quote
                                </button>
                            </div>
                        </form>                                              
                    </div>  
                    <div className='sm:hidden'>
                        <form className='text-center w-full space-y-5' onSubmit={(e) => submit(e)}>
                            <div className='flex justify-around'>
                                <div>
                                    <label className="block uppercase text-gray-500 text-sm font-bold mb-2">
                                        Residence Type
                                    </label>
                                    <select className="indent-2 h-11 text-orange-600 text-center bg-white w-36 shadow border rounded  focus:outline-none focus:shadow-outline focus:shadow-md focus:border-amber-200 focus:shadow-amber-200 focus:ring-1 ring-amber-200"
                                        name="unitType" value={unitType} onChange={(e) => handleUnitTypeChange(e)} style={{ transition: "all .15s ease" }} required>
                                        <option>HDB</option>
                                        <option>Condo</option>
                                        <option>Landed</option>
                                    </select>
                                </div> 
                                <div>
                                    <label className="block uppercase text-gray-500 text-sm font-bold mb-2">
                                        Floor Size (Sqft)
                                    </label>
                                    <input
                                        type="number" min={300}
                                        className="px-3 py-3 h-11 text-orange-600 w-36 text-center shadow appearance-none border rounded  focus:outline-none focus:shadow-outline focus:shadow-md focus:border-amber-200 focus:shadow-amber-200 focus:ring-1 ring-amber-200"
                                        placeholder="Floor size" name="floorSize" value={floorSize} onChange={(e) => handleFloorSizeChange(e)}
                                        style={{ transition: "all .15s ease" }} required
                                    />
                                </div> 
                            </div>
                            <div className='text-center'>
                                <button className='py-3 px-6 rounded-full bg-linear-to-tr from-orange-600 to-amber-400 text-white' type="submit">
                                    Get Quote
                                </button>
                            </div>
                        </form>
                        <div className='text-center'>
                            <button type='button' className='text-orange-600 text-sm py-3 px-4 rounded-xl  text-center space-y-5' onClick={() => openRequestForm()}>
                                <span>More Options</span>
                            </button>
                        </div> 
                    </div>
                    <div className='flex justify-center items-center pt-5 w-full text-sm px-2'>
                        <div className='grid grid-cols-2 gap-3'>
                            <div className='flex items-center space-x-2'>
                                <span className='bg-white text-orange-600 text-xl rounded-full'>
                                    <FaCheckCircle/>
                                </span>
                                <span>Cheapest pricing</span>
                            </div>
                            <div className='flex items-center space-x-2'>
                                <span className='bg-white text-orange-600 text-xl rounded-full'>
                                    <FaCheckCircle/>
                                </span>
                                <span>Instant booking</span>
                            </div>                                                     
                            <div className='flex items-center space-x-2'>
                                <span className='bg-white text-orange-600 text-xl rounded-full'>
                                    <FaCheckCircle/>
                                </span>
                                <span>Legal workers</span>
                            </div>
                            <div className='flex items-center space-x-2'>
                                <span className='bg-white text-orange-600 text-xl rounded-full'>
                                    <FaCheckCircle/>
                                </span>
                                <span>No hidden fees</span>
                            </div>  
                        </div>
                    </div>  
                    <div className='text-center text-sm pt-8'>
                        <button type="button" className='text-gray-500 sm:text-white sm:text-base flex items-center justify-center w-full' onClick={() => showJobScope()}>
                            <span>Service Inclusions&nbsp;</span>
                            <FaQuestionCircle className='text-base text-orange-600 sm:bg-white rounded-full'/>
                        </button>
                    </div>
                </div>   
            </div>
        </div>
    </>
  )
}